import { type RequiredMap, Typography } from "@pmag/ui-components";
import { SPFAvailabilityStatus } from "@src/utils/events";
import { type FunctionComponent, type ReactNode } from "react";
import { FormattedMessage } from "react-intl";

export const dataTestId = {
    available: "sparePartsFinder.subgroupPage.availabilityStatusMessage.available",
    notAvailable: "sparePartsFinder.subgroupPage.availabilityStatusMessage.notAvailable",
    manufacturerAvailable: "sparePartsFinder.subgroupPage.availabilityStatusMessage.manufacturerAvailable",
    unknown: "sparePartsFinder.subgroupPage.availabilityStatusMessage.unknown",
};

export interface AvailabilityStatusMessageProps {
    availabilityStatus: SPFAvailabilityStatus;
}

const availabilityStatusMessageMap: RequiredMap<SPFAvailabilityStatus, ReactNode> = {
    [SPFAvailabilityStatus.Available]: (
        <Typography variant="label-01" data-testid={dataTestId.available}>
            <FormattedMessage id="sparePartsFinder.subgroupPage.availabilityStatusMessage.available" defaultMessage="Available" />
        </Typography>
    ),
    [SPFAvailabilityStatus.NotAvailable]: (
        <Typography variant="label-01" data-testid={dataTestId.notAvailable}>
            <FormattedMessage id="sparePartsFinder.subgroupPage.availabilityStatusMessage.notAvailable" defaultMessage="Not available" />
        </Typography>
    ),
    [SPFAvailabilityStatus.ManufacturerAvailable]: (
        <Typography variant="label-01" data-testid={dataTestId.manufacturerAvailable}>
            <FormattedMessage
                id="sparePartsFinder.subgroupPage.availabilityStatusMessage.manufacturerAvailable"
                defaultMessage="Available at manufacturer"
            />
        </Typography>
    ),
    [SPFAvailabilityStatus.Unknown]: (
        <Typography variant="label-01" data-testid={dataTestId.unknown}>
            <FormattedMessage id="sparePartsFinder.subgroupPage.availabilityStatusMessage.unknown" defaultMessage="Unknown" />
        </Typography>
    ),
};

export const AvailabilityStatusMessage: FunctionComponent<AvailabilityStatusMessageProps> = ({ availabilityStatus }) => (
    <>{availabilityStatusMessageMap[availabilityStatus]}</>
);
